const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : "";
const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;


export const defaultColumnsOrder = [
  "Slno",
  "Code",
  "Description",
  "Location",
  "Unit",
  "Qty",
  "Unit Price",
  "Disc%",
  "Disc Amount",
  "amount",
  "VAT",
  "Vat%",
  "VATamt",
  "cntrl",
  "Fraction",
  "Dono",
  "Sono",
  "Quotno",
  "Avlqty",
  "BDiscsplit",
  "Total",
  "OEM",
  "Bin",
  "UPrice.VInc",
  "Comm",
  "Unit_Com",
];

// Mapping labels to internal data field names
export const columnFieldMap = {
  Slno: "sino",
  Code: "code",
  Description: "description",
  Location: "location",
  Unit: "unit",
  Qty: "qty",
  "Unit Price": "unitPrice",
  "Disc Amount": "DiscountAmount",
  "Disc%": "Discount%",
  Amount: "amount",
  cntrl: "cntrl",
  Fraction: "fraction",
  "Vat%": "vatPercent",
  VAT: "vatEnabled",
  Dono: "dono",
  Sono: "sono",
  Quotno: "quotno",
  Avlqty: "avlqty",
  VATamt: "vatAmount",
  BDiscsplit: "bDiscSplit",
  Total: "total",
  OEM: "oem",
  Bin: "bin",
  "UPrice.VInc": "uPriceVInc",
  Comm: "comm",
  Unit_Com: "Unit_Com",
};

export const getBaseColumn = (
  field,
  widthMap,
  renderers,
  locationOptions,
  unitOptions
) => {
  const baseConfig = {
    field,
    headerName:
      Object.entries(columnFieldMap).find(
        ([, value]) => value === field
      )?.[0] || field,
    width: widthMap?.[field] || 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
  };

  if (
    [
      "qty",
      "unitPrice",
      "Discount%",
      "DiscountAmount",
      "vatPercent",
      "vatAmount",
      "uPriceVInc",
      "comm",
      "fraction",
      "total",
      "bDiscSplit",
      "avlqty",
      "amount",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderEditableCell(params, field, "number"),
    };
  }

  if (
    [
      "code",
      "description",
      "dono",
      "sono",
      "quotno",
      "oem",
      "bin",
      "cntrl",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) => renderers.renderEditableCell(params, field),
    };
  }

  if (field === "location") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "location", locationOptions),
    };
  }

  if (field === "unit") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "unit", unitOptions),
    };
  }
  if (field === "vatEnabled") {
    return {
      ...baseConfig,
      headerName: "VAT",
      width: widthMap?.[field] || 60,
      renderCell: (params) => renderers.renderVatToggle(params, field),
    };
  }

  return baseConfig;
};

export const defaultColumnPercents = {
  sino: 5,
  code: 10,
  description: 20,
  location: 10,
  unit: 8,
  qty: 8,
  unitPrice: 8,
  "Discount%": 8,
  actions: 5,
};

// FIXED: Calculate row values with proper manual total edit handling
export const calculateRowValues = (item, invoiceData) => {
  const qty = Number(item.qty) || 0;
  const unitPrice = Number(item.unitPrice) || 0;
  const discountPercent = Number(item["Discount%"]) || 0;
  const discountAmount = Number(item.DiscountAmount) || 0;

  // Get document-level VAT status (5% or 0%)
  const documentVatPercent = invoiceData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;

  // Line-level VAT: Check if VAT is enabled for this specific line
  // If vatEnabled is explicitly false, use 0%, otherwise use document VAT percent
  const lineVatEnabled = item.vatEnabled !== false;
  const vatPercent = lineVatEnabled ? documentVatPercent : 0;

  // If user has manually edited the total field (and unit price was derived from it)
  // Keep using the manually derived unit price until user changes qty/price/discount
  if (item._manualTotalEdit && item.total !== undefined && item.total !== "") {
    const manualTotal = Number(item.total);

    // Reverse calculate: Total -> Amount -> Unit Price
    // Formula: Total = Amount + VAT
    // So: Amount = Total / (1 + vatPercent/100)
    const amount =
      vatPercent > 0 ? manualTotal / (1 + vatPercent / 100) : manualTotal;
    const vatAmount = manualTotal - amount;

    // Reverse calculate unit price from amount
    // Formula: Amount = (Qty * UnitPrice) - Discounts
    // Calculate gross before discount
    const grossBeforeDiscount =
      amount + (amount * discountPercent) / 100 + discountAmount;
    const newUnitPrice = qty > 0 ? grossBeforeDiscount / qty : 0;

    return {
      ...item,
      amount: amount.toFixed(2),
      vatAmount: vatAmount.toFixed(2),
      vatPercent, // Update line VAT percent
      unitPrice: newUnitPrice.toFixed(2),
      uPriceVInc: (newUnitPrice * (1 + vatPercent / 100)).toFixed(2),
      total: manualTotal.toFixed(2), // Keep the manual total
      _manualTotalEdit: true, // IMPORTANT: Keep this flag!
    };
  }

  // Normal calculation (forward calculation)
  const exclusiveAmount = qty * unitPrice;
  const percentageDiscountAmount = (exclusiveAmount * discountPercent) / 100;
  const totalDiscount = percentageDiscountAmount + discountAmount;
  const amount = exclusiveAmount - totalDiscount;

  // Calculate VAT based on line-level setting
  const vatAmount = Math.round((amount * vatPercent)) / 100;
  const total = amount + vatAmount;
  const uPriceVInc = unitPrice * (1 + vatPercent / 100);

  return {
    ...item,
    amount: amount.toFixed(2),
    vatAmount: vatAmount.toFixed(2),
    vatPercent, // Update line VAT percent based on document + line settings
    total: total.toFixed(2),
    uPriceVInc: uPriceVInc.toFixed(2),
    DiscountAmount: discountAmount.toFixed(2),
    "Discount%": discountPercent.toFixed(2),
  };
};

// Get VAT percentage from invoice data
export const getVatPercent = (invoiceData) => {
  return invoiceData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;
};

// Required fields for validation
export const requiredFields = [
  "code",
  "description",
  "location",
  "unit",
  "qty",
  "unitPrice",
];

// Template for new items
export const newItemTemplate = (id, sino, defaultLocation) => ({
  id,
  sino,
  code: "",
  description: "",
  location: defaultLocation,
  unit: "",
  qty: 0,
  unitPrice: 0,
  discount: 0,
  DiscountAmount: 0,
  "Discount%": 0,
  vatEnabled: true, // Default: VAT enabled (will use document VAT %)
  isIncluded: true,
});

// Screen code for column preferences
export const screenCode = "SALESINVOICE";

// Export complete config object
export const salesInvoiceConfig = {
  columnFieldMap,
  defaultColumnsOrder,
  getBaseColumn,
  calculateRowValues,
  getVatPercent,
  screenCode,
  defaultColumnPercents,
  requiredFields,
  newItemTemplate,
};
